import { useState } from "react";

// UI components
import LoadingSpinner from "../loadingSpinner";
import { Container, Row, Col } from "react-bootstrap";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TextField, Button } from "@mui/material/";

export default function AddRemoteVideo(props) {
  const showDialog = props.showDialog;

  const [videoURL, setVideoURL] = useState("");
  const [videoTitle, setVideoTitle] = useState("");

  const isLoading = props.isLoading;
  const [isError, setError] = useState(props.isError);

  const handleAdd = () => {
    // 1. Empty check
    if (!videoURL.trim()) {
      setError("Please enter a video URL.");
      return;
    }

    // 2. Generic URL validation
    try {
      new URL(videoURL);
    } catch (_) {
      setError("Invalid URL format.");
      return;
    }

    setError("");
    props.onAdd(videoURL, videoTitle);
    setVideoURL("");
  };

  return (
    <Dialog
      open={showDialog}
      onClose={() => props.onClose()}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        <Button onClick={() => props.onClose()}>
          <CloseIcon />
        </Button>
      </DialogTitle>
      <DialogContent>
        <Container fluid>
          <Row>
            {(isError || isLoading) && (
              <Col sm={12}>
                {isLoading && (
                  <Box
                    sx={{
                      display: "flex",
                      position: "absolute",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                      height: "100%",
                      top: 0,
                      left: 0,
                      backgroundColor: "rgba(255, 255, 255, 0.75)",
                      zIndex: 10,
                    }}
                  >
                    <LoadingSpinner containerStyleCss={{ paddingTop: 0 }} />
                  </Box>
                )}
              </Col>
            )}
            <>
              <Col sm={12} className="mb-3">
                <TextField
                  className="title-input"
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={videoTitle}
                  placeholder="Enter title for the video (optional)"
                  onChange={(event) => {
                    setVideoTitle(event.target.value);
                  }}
                />
              </Col>
              <Col sm={12}>
                <TextField
                  className="video-url-input"
                  fullWidth
                  size="small"
                  variant="outlined"
                  value={videoURL}
                  placeholder="Enter full video URL (e.g. https://www.youtube.com/watch?v=...)"
                  error={Boolean(isError)}
                  helperText={isError}
                  onChange={(event) => {
                    setVideoURL(event.target.value);
                  }}
                />
              </Col>
            </>
          </Row>
        </Container>
      </DialogContent>
      <DialogActions>
        <Container>
          <Row>
            <Col className="text-end">
              <Button
                sx={{ mb: 2 }}
                variant="contained"
                color="primary"
                className="btn btn-primary"
                onClick={handleAdd}
              >
                Add Video
              </Button>
            </Col>
          </Row>
        </Container>
      </DialogActions>
    </Dialog>
  );
}
